import { CESesMessageBase } from './ce-ses-message-base'


export class CESesMessage extends CESesMessageBase {

}